module.exports = __webpack_public_path__ + "img/lashes1.2ecad9e9.jpg";